import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { AdaptSignalRModule } from "@common/lib/signalr-provider/signalr.module";
import { SignalRService } from "@common/lib/signalr-provider/signalr.service";
import { provideApplicationBarItemType } from "@common/shell/application-bar/application-bar.component";
import { AdaptCommonUserModule } from "@common/user/adapt-common-user.module";
import { AdaptCommonDialogModule } from "@common/ux/adapt-common-dialog/adapt-common-dialog.module";
import { AdaptButtonModule } from "@common/ux/button/button.module";
import { AdaptDashboardElementModule } from "@common/ux/dashboard-element/dashboard-element.module";
import { AdaptDateModule } from "@common/ux/date/date.module";
import { AdaptLoadingSpinnerModule } from "@common/ux/loading-spinner/loading-spinner.module";
import { AdaptTooltipModule } from "@common/ux/tooltip.directive/tooltip.module";
import { DxScrollViewModule, DxTreeViewModule } from "devextreme-angular";
import { ActivityFeedComponent } from "./activity-feed/activity-feed.component";
import { ActivityFeedDateGroupComponent } from "./activity-feed-date-group/activity-feed-date-group.component";
import { ActivityFeedDialogComponent } from "./activity-feed-dialog/activity-feed-dialog.component";
import { ActivityFeedSignalRHub } from "./activity-feed-signalr-hub";
import { ActivityInstanceComponent } from "./activity-instance/activity-instance.component";
import { ActivityNotificationComponent } from "./activity-notification/activity-notification.component";
import { ApplicationBarNotificationItem } from "./activity-notification/application-bar-notification-item";
import { ActivityNotificationContentComponent } from "./activity-notification-content/activity-notification-content.component";
import { OrganisationActivityFeedComponent } from "./organisation-activity-feed/organisation-activity-feed.component";
import { PersonalActivityFeedComponent } from "./personal-activity-feed/personal-activity-feed.component";
import { PersonalActivityFeedPageComponent, PersonalActivityFeedPageRoute } from "./personal-activity-feed-page/personal-activity-feed-page.component";
import { TeamActivityFeedComponent } from "./team-activity-feed/team-activity-feed.component";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        DxTreeViewModule,
        DxScrollViewModule,
        AdaptDateModule,
        AdaptTooltipModule,
        AdaptCommonUserModule,
        AdaptLoadingSpinnerModule,
        AdaptSignalRModule,
        AdaptButtonModule,
        AdaptDashboardElementModule,
        AdaptCommonDialogModule,
    ],
    exports: [
        ActivityFeedComponent,
        ActivityNotificationComponent,
        PersonalActivityFeedComponent,
        TeamActivityFeedComponent,
        OrganisationActivityFeedComponent,
        ActivityFeedDialogComponent,
    ],
    declarations: [
        ActivityInstanceComponent,
        ActivityFeedDateGroupComponent,
        ActivityFeedComponent,
        ActivityNotificationComponent,
        ActivityNotificationContentComponent,
        PersonalActivityFeedComponent,
        TeamActivityFeedComponent,
        OrganisationActivityFeedComponent,
        PersonalActivityFeedPageComponent,
        ActivityFeedDialogComponent,
    ],
    providers: [
        provideApplicationBarItemType(ApplicationBarNotificationItem),
    ],
})
export class AdaptActivityFeedModule {
    public static readonly Routes = [
        ...PersonalActivityFeedPageRoute.routes,
    ];

    constructor() {
        SignalRService.registerHubImplementation(ActivityFeedSignalRHub.Name, ActivityFeedSignalRHub);
    }
}
